var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgressIconInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1001 14L6.6001 6.5L10.1001 11.5L14.6001 2.5",
    stroke: "#595959",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 2,
    y2: 2,
    stroke: "#595959",
    strokeMiterlimit: 3.99933,
    strokeLinecap: "round",
    strokeDasharray: "0.5 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14,
    x2: 14,
    y2: 14,
    stroke: "#595959",
    strokeMiterlimit: 3.99933,
    strokeLinecap: "round",
    strokeDasharray: "0.5 2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIconInactive);
export default __webpack_public_path__ + "static/media/progress-icon-inactive.e55f68ab519a9335493089b40db0e98c.svg";
export { ForwardRef as ReactComponent };